import { useState, useEffect } from "react";

export function useExitIntent(delay = 4000) {
  const [showIntent, setShowIntent] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("exit-intent-dismissed");
    if (dismissed) return;

    let timer;
    let active = false;

    const activate = () => { active = true; };
    const handleMouseLeave = (e) => {
      if (!active || e.clientY > 10) return;
      setShowIntent(true);
    };

    timer = setTimeout(activate, delay);
    document.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [delay]);

  const dismiss = () => {
    setShowIntent(false);
    sessionStorage.setItem("exit-intent-dismissed", "1");
  };

  return { showIntent, dismiss };
}
